import { render, staticRenderFns } from "./MasterForm.vue?vue&type=template&id=5efd7dac&scoped=true"
import script from "./MasterForm.vue?vue&type=script&lang=js"
export * from "./MasterForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5efd7dac",
  null
  
)

export default component.exports